var _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCorrecting = function SvgCorrecting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FFB800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.856 6.855a.643.643 0 0 0-.643.643v7.715c0 1.42 1.15 2.57 2.57 2.571h6.43c.98 0 1.656-.423 2.064-.99a2.796 2.796 0 0 0 .507-1.581.643.643 0 0 0-.643-.643h-1.928V7.498a.643.643 0 0 0-.643-.643H6.855Zm3.857 7.715h3.214V8.14H7.498v7.072c0 .71.576 1.285 1.286 1.285h.001c.22 0 .56-.07.829-.264.236-.17.456-.46.456-1.021 0-.355.288-.643.643-.643Zm.34 1.928h4.16c.562 0 .85-.22 1.02-.456.044-.06.08-.122.112-.187h-5.056a2.448 2.448 0 0 1-.236.643ZM8.784 10.07c0-.355.288-.643.643-.643h2.571a.643.643 0 0 1 0 1.286H9.427a.643.643 0 0 1-.643-.643Zm.643 1.285a.643.643 0 1 0 0 1.286h2.571a.643.643 0 0 0 0-1.286H9.427Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FFB800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.766 7.1a.7.7 0 0 1 .7-.7h8.4a.7.7 0 0 1 .7.7v3.874a2.799 2.799 0 0 1 .858 4.08l1.907 2.22a.7.7 0 0 1-.99.99l-1.775-2.067v1.402a.7.7 0 0 1-.7.7h-8.4a.7.7 0 0 1-.7-.7V7.1Zm8.4 9.1a2.799 2.799 0 0 1-2.426-1.4H8.566a.7.7 0 1 1 0-1.4h2.8c0-.242.03-.477.088-.7H8.566a.7.7 0 1 1 0-1.4h3.5c.073 0 .144.01.211.032a2.79 2.79 0 0 1 1.889-.733V7.8h-7v9.1h7v-.7Zm-5.6-7a.7.7 0 1 0 0 1.4h4.2a.7.7 0 1 0 0-1.4h-4.2Zm5.6 5.6a1.4 1.4 0 1 0 0-2.8 1.4 1.4 0 0 0 0 2.8Z"
  })));
};
export default SvgCorrecting;